import { useCallback, useState } from "react";
import { LayoutChangeEvent, View } from "react-native";
import Animated, { useAnimatedStyle } from "react-native-reanimated";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import useLoading from "./hooks/useLoading";
import { LoadingBarProps } from "./types";

const LoadingBar = ({ style, animatedBarStyle, borderRadius = 8, ...props }: LoadingBarProps) => {
	const { progressSV } = useLoading(props);

	const { theme } = useStyle();
	const [width, setWidth] = useState(0);
	const animatedStyle = useAnimatedStyle(
		() => ({
			transform: [{ translateX: -((1 - progressSV.value) * width) }],
		}),
		[progressSV, width],
	);
	const handleLayout = useCallback((e: LayoutChangeEvent) => {
		setWidth(e.nativeEvent.layout.width);
	}, []);

	return (
		<View
			onLayout={handleLayout}
			style={[
				{
					backgroundColor: "#00000040",
					height: 12,
					overflow: "hidden",
				},
				style,
				{
					borderRadius,
				},
			]}
		>
			{!!width && (
				<Animated.View
					style={[
						{
							backgroundColor: color.Text[theme],
						},
						animatedBarStyle,
						animatedStyle,
						{
							width: "100%",
							height: "100%",
							borderRadius,
						},
					]}
				/>
			)}
		</View>
	);
};
export default LoadingBar;
